import React from 'react';
import { PageContainer, PageHeader } from '../../components/Page';
import { withGoogleMap, GoogleMap, Marker } from 'react-google-maps';
import withScriptjs from "react-google-maps/lib/withScriptjs";
import mapStyles from './mapstyles.json';
import Helmet from 'react-helmet';
import { withRouteData } from "react-static";
import DangerousHTML from '../../components/DangerousHTML';

const mapSettings = {
  panControl: false,
  mapTypeControl: false,
  scrollwheel: false,
  defaultZoom: 14,
  defaultOptions: {
    styles: mapStyles,
  },
  defaultCenter: {
    lat: 33.61841886854701,
    lng: -78.9742848160858,
  },
};

const GoogleMapsKey = 'AIzaSyCrRYxyG6XH0Rnr7RX1BfaJmCKD9fgB9gc';
const markerSettings = {
  style: {
    backgroundColor: '#22b24c',
    borderRadius: '50px',
    width: '50px',
    height: '50px',
  },
  position: {
    lat: 33.615444,
    lng: -78.984622,
  },
};

const MJSMap = withScriptjs(
  withGoogleMap(() => (<GoogleMap {...mapSettings} >
    <Marker {...markerSettings} />
  </GoogleMap>)));

export default withRouteData(({ content }) => (<React.Fragment>
  <Helmet title={content ? content.title : ''} />
  <PageContainer>
    <PageHeader image={content ? content.headerImage : ''} />
    <div className="col-xs-offset-1 col-xs-11 col-sm-offset-1 col-sm-11 col-md-12">
      <DangerousHTML html={content ? content.body : ''} />
      <br />
      <div className="row">
        <div className="col-xs-12 col-sm-6 col-md-3 col-lg-4">
          <address>
            <strong>Office Location:</strong><br />1271 Glenns Bay Road<br />Surfside Beach, SC 29575
          </address>
        </div>
        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-4">
          <address>
            <strong>Mailing Address:</strong><br />Moore, Johnson &amp; Saraniti<br />P.O. Box 14737<br />Surfside Beach, SC 29587
          </address>
        </div>
        <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4">
          <dl className="dl-horizontal">
            <dt>Office Line:</dt>
            <dd><a href="tel:8436509757">(843) 650-9757</a></dd>
            <dt>Fax Line:</dt>
            <dd>(843) 650-9747</dd>
            <dt>Office Hours:</dt>
            <dd>Monday - Friday<br />8:30am to 5:30pm</dd>
          </dl>
        </div>
      </div>
    </div>
    <div className="col-md-10 col-sm-10 col-sm-offset-1 page-content">
      <MJSMap
        googleMapURL={`https://maps.googleapis.com/maps/api/js?v=3.exp&key=${GoogleMapsKey}`}
        loadingElement={<div />}
        containerElement={<div style={{ width: '100%', height: '315px' }} />}
        mapElement={<div style={{ width: '100%', height: '100%' }} />}
      />
      <br /><br /><br />
    </div>
  </PageContainer>
</React.Fragment>));
